import './Page.css';

export default function Contact() {
  return (
    <div className='page'>
      <h2 className='subheadline-black exception-3'>Organizator:</h2>
      <img
        className='logo-contact'
        src={`${process.env.PUBLIC_URL}/img/logo/logo-nasze-talki.svg`}
        alt='Logo stowarzyszenia Nasze Talki'
      />
      <div className='page-text'>
        <h3 className='subheadline-upper'>
          WSPÓLNOTA &#x2022; KULTURA &#x2022; SZTUKA &#x2022; EDUKACJA &#x2022; EKOLOGIA
        </h3>

        <p>
          Stowarzyszenie „Nasze Talki” to organizacja pozarządowa, działająca na
          terenie mazurskiej wsi Talki, położonej w gminie Wydminy (pow.
          giżycki). Od 2008 roku wspólnie chronimy krajobraz, integrujemy
          lokalną społeczność, organizujemy wydarzenia kulturalne. Naszą misją
          jest wspieranie zrównoważonego rozwoju otoczenia bliskiego naszemu
          sercu. Chcemy by wieś Talki i całe Mazury były miejscem dobrym do
          życia, aktywnym i otwartym, przyjaznym ludziom i naturze.
        </p>

        <h3 className='subheadline-upper'>Integracja mieszkańców</h3>
        <p>
          Organizujemy wydarzenia, warsztaty i spotkania, które zbliżają
          pokolenia i budują lokalną tożsamość.
        </p>

        <h3 className='subheadline-upper'>Ochrona środowiska</h3>
        <p>
          Promujemy odpowiedzialne gospodarowanie zasobami. Podejmujemy
          inicjatywy proekologiczne w obronie niezwykle wartościowego krajobrazu
          - jego urody i przystępności dla mieszkańców i turystów.
        </p>

        <h3 className='subheadline-upper'>Kultura i edukacja</h3>
        <p>
          Wspieramy rozwój dzieci, młodzieży i dorosłych, pielęgnując lokalne
          tradycje poprzez organizację wydarzeń kulturalnych, które tak jak nasz
          flagowy projekt: Otwarte Pracownie na Mazurach, daleko przekraczają
          granice maleńkiej wsi Talki.
        </p>

        <h3 className='subheadline-upper'>
          Infrastruktura i estetyka przestrzeni
        </h3>
        <p>
          Zabiegamy o poprawę warunków życia mieszkańców, w tym, o drogi,
          kanalizację, oświetlenie i zieleń.
        </p>

        <h3 className='subheadline-upper'>Aktywność obywatelska</h3>
        <p>
          Angażujemy się w działania legislacyjne i konsultacyjne, wspierając
          demokrację lokalną i głos mieszkańców.
        </p>

        <ul>
          W ostatnich latach Stowarzyszenie:
          <li>
            zainicjowało projekt uchwały w sprawie utworzenia Zespołu
            Przyrodniczo-Krajobrazowego im. Andrzeja Haręzy – w trosce o
            zachowanie walorów krajobrazowych Talek
          </li>
          <li>
            organizuje coroczną akcję - Otwarte Pracownie na Mazurach,
            zrzeszającą i promującą mazurskich artystów i rękodzielników;
          </li>
          <li>
            zorganizowało spotkania edukacyjne z ekspertami, m.in., z zakresu
            ochrony wilków i bioróżnorodności;
          </li>
          <li>
            zaangażowało się w protesty, działania informacyjne i prawnicze,
            dotyczące zagrożeń dla lokalnego środowiska - takich jak duże
            inwestycje przemysłowe rujnujące czystość i piękno Mazur;
          </li>
          <li>
            wspierało inicjatywy sąsiedzkie i obywatelskie w zakresie
            rewitalizacji przestrzeni wspólnych oraz własnych posesji.
          </li>
        </ul>

        <h3 className='subheadline-upper'>
          <b>Dołącz do nas</b>
        </h3>

        <p>
          Chcesz mieć realny wpływ na to co dzieje się w Twojej wsi? Dołącz do
          Stowarzyszenia „Nasze Talki”. Szukamy aktywnych mieszkańców,
          wolontariuszy, sympatyków lokalnej przyrody i kultury. Razem możemy
          więcej dla ludzi i dla środowiska.
        </p>

        <p>
          <a href='mailto:grafelinska@gmail.com'>
            <b>Skontaktuj się z nami: grafelinska@gmail.com</b>
          </a>
        </p>
      </div>
    </div>
  );
}
